import { Spin } from 'antd'
import { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/DocumentTableColumns'
import { useDocumentThumbnail } from 'features/knowledgeDocumentViewer/hooks/useDocumentThumbnail'
import React from 'react'
import styled from 'styled-components'

const CARD_WIDTH = 120
const THUMBNAIL_HEIGHT = 100

const Card = styled.button`
  display: flex;
  flex-direction: column;
  width: ${CARD_WIDTH}px;
  flex-shrink: 0;
  padding: 0.25rem;
  background: ${(props) => props.theme.forecast.defaultButton};
  border-radius: 0.25rem;
  overflow: hidden;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${(props) => props.theme.forecast.hoverButton};
  }
  &:active {
    background-color: ${(props) => props.theme.forecast.activeButton};
    color: ${(props) => props.theme.forecast.activeText};
  }
`

const ThumbnailContainer = styled.div`
  width: 100%;
  height: ${THUMBNAIL_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: ${(props) => props.theme.forecast.cardGroupBackground};
`

const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.375rem 0.25rem 0 0.25rem;
  gap: 0.125rem;
`

const DrawingNumber = styled.span`
  font-size: 0.625rem;
  color: ${(props) => props.theme.forecast.secondaryText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Title = styled.span`
  font-size: 0.6875rem;
  font-weight: 500;
  color: ${(props) => props.theme.forecast.defaultText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

interface RecentDocumentCardProps {
  document: DocumentTableRow
  onClick: (document: DocumentTableRow, event?: React.MouseEvent) => void
}

export const RecentDocumentCard: React.FC<RecentDocumentCardProps> = ({
  document,
  onClick,
}) => {
  const { thumbnailUrl, isLoading } = useDocumentThumbnail({
    document,
    scale: 1,
  })

  const handleClick = (event: React.MouseEvent) => {
    onClick(document, event)
  }

  const displayTitle = document.documentTitle || document.title
  const displayDrawingNumber =
    document.drawing ||
    (displayTitle !== document.title ? document.title : null)

  return (
    <Card onClick={handleClick} title={displayTitle}>
      <ThumbnailContainer>
        {isLoading ? (
          <Spin size='small' />
        ) : thumbnailUrl ? (
          <ThumbnailImage src={thumbnailUrl} alt={displayTitle} />
        ) : null}
      </ThumbnailContainer>
      <CardContent>
        {displayDrawingNumber && (
          <DrawingNumber>{displayDrawingNumber}</DrawingNumber>
        )}
        <Title>{displayTitle}</Title>
      </CardContent>
    </Card>
  )
}
